import classNames from 'classnames';
import type { ReactNode } from 'react';

interface DividerProps {
  className?: string;
  children?: ReactNode;
}

const Divider = ({ className, children }: DividerProps) => (
  <div className={classNames('w-100 position-relative text-center', className)}>
    <hr className="text-300" />
    <div className="divider-content-center">{children}</div>
  </div>
);

export default Divider;
